import { themeColors } from "../../config.js";
export const IDEStyles = {
  tabRow: {
    display: "flex",
    alignSelf: "stretch",
    flexDirection: "row",
    flexShrink: 0,
    justifyContent: "flex-start",
    alignItems: "stretch",
    overflowX: "auto",
    height: 20,
    fontFamily: "roboto",
    fontSize: 13,
    backgroundColor: themeColors.optionColor,
    color: themeColors.optionTextColor,
  },
  tabCell: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: themeColors.optionColor,
    color: themeColors.optionTextColor,
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: themeColors.borderColor,
    width: 100,
    padding: 5,
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
};
